import { Backdrop, CircularProgress } from "@mui/material";

export const PageLoader = (): JSX.Element => {
  return (
    <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
